import {
  FeatureSpotlight,
  featureSpotlightImageSrc,
  type FeatureSpotlightItem,
} from '@/components/marketing/feature-spotlight'

export function FeatureSpotlightStack({ spotlights }: { spotlights: FeatureSpotlightItem[] }) {
  return (
    <section className="feature-spotlight-stack">
      <div className="marketing-container feature-spotlight-stack__list">
        {spotlights.map((spotlight, index) => (
          <FeatureSpotlight
            key={spotlight.title}
            kicker={spotlight.kicker}
            title={spotlight.title}
            lead={spotlight.lead}
            imageSrc={featureSpotlightImageSrc(spotlight.imageSlug)}
            imageAlt={spotlight.imageAlt}
            ctaLabel={spotlight.ctaLabel}
            ctaHref={spotlight.ctaHref}
            imageSide={spotlight.imageSide ?? (index % 2 === 0 ? 'right' : 'left')}
            prompts={spotlight.prompts}
          />
        ))}
      </div>
    </section>
  )
}
